import { render } from "./DashboardVotingVx.vue?vue&type=template&id=195fa0de&scoped=true"
import script from "./DashboardVotingVx.vue?vue&type=script&lang=js"
export * from "./DashboardVotingVx.vue?vue&type=script&lang=js"

import "./DashboardVotingVx.vue?vue&type=style&index=0&id=195fa0de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195fa0de"]])

export default __exports__